<script setup lang="ts">
import MdiFaIcon from '../MdiFaIcon.vue';
import { ControlButtons } from '../types/share';

type Emits = {
  (e: 'click'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  ctrlBtn: ControlButtons;
  isTouchDevice?: boolean;
  iconSize?: string;
};
withDefaults(defineProps<Props>(), {
  isTouchDevice: false,
  iconSize: 'large',
});
</script>

<template>
  <v-btn
    :key="ctrlBtn.title"
    :variant="ctrlBtn.isActive ? 'tonal' : 'text'"
    class="ml-1 ctrl-btn"
    :loading="ctrlBtn.isLoading"
    size="48"
    :color="ctrlBtn.iconColor ?? 'currentColor'"
    :aria-label="ctrlBtn.title"
    @click="emit('click')"
  >
    <MdiFaIcon :icon="ctrlBtn.icon" :size="iconSize" v-bind="ctrlBtn.iconProps"></MdiFaIcon>
    <v-tooltip :disabled="isTouchDevice" :text="ctrlBtn.title" activator="parent" location="top" :aria-hidden="true" />
    <slot></slot>
  </v-btn>
</template>

<style scoped lang="scss"></style>
